import { LayoutNode } from './../layout/layout-node';
import { LayerManager } from './layer-manager';

export abstract class VisualNode {
    public zIndex: number = LayerManager.zIndexOther;
    public layoutNode: LayoutNode;
    protected parent: VisualNode;

    public static layerManager: LayerManager;

    constructor(layoutNode: LayoutNode) {
        if (!VisualNode.layerManager) {
            VisualNode.layerManager = new LayerManager();
        }
        this.layoutNode = layoutNode;

        VisualNode.layerManager.addNode(this);
    }

    public init() {
        this.initdraw();
        this.layoutNode.positionUpdated.attach(() => {
            this.redraw();
        });
    }

    protected abstract redraw(): void;
    protected abstract initdraw(): void;
    protected abstract handleHover(): void;
    protected abstract handleOut(): void;

    public addChild(node: VisualNode) {
        node.addParent(this);
        this.layoutNode.addChild(node.layoutNode);
    }

    public addParent(node: VisualNode) {
        this.parent = node;
    }
}
